/**
 * Get percents
 * @param {PropertyValueProps} value
 * @returns {String}
 */
const getPercentsString = (value) => {
  return /** @type {String} */ (value.get("v_output"));
};

export default getPercentsString;
